/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Warmup_Method_ClassicInputs */

const en_us2_workout_logging_warmup_method_classic = /** @type {(inputs: Workout_Logging_Warmup_Method_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classic`)
};

const pt_br2_workout_logging_warmup_method_classic = /** @type {(inputs: Workout_Logging_Warmup_Method_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clássico`)
};

const es_419_workout_logging_warmup_method_classic = /** @type {(inputs: Workout_Logging_Warmup_Method_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clásico`)
};

const pt_pt2_workout_logging_warmup_method_classic = /** @type {(inputs: Workout_Logging_Warmup_Method_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clássico`)
};

const fr_fr2_workout_logging_warmup_method_classic = /** @type {(inputs: Workout_Logging_Warmup_Method_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classique`)
};

const de_de2_workout_logging_warmup_method_classic = /** @type {(inputs: Workout_Logging_Warmup_Method_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klassisch`)
};

const it_it2_workout_logging_warmup_method_classic = /** @type {(inputs: Workout_Logging_Warmup_Method_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classico`)
};

/**
* | output |
* | --- |
* | "Classic" |
*
* @param {Workout_Logging_Warmup_Method_ClassicInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_warmup_method_classic = /** @type {((inputs?: Workout_Logging_Warmup_Method_ClassicInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Warmup_Method_ClassicInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_warmup_method_classic(inputs)
	if (locale === "es-419") return es_419_workout_logging_warmup_method_classic(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_warmup_method_classic(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_warmup_method_classic(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_warmup_method_classic(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_warmup_method_classic(inputs)
	return en_us2_workout_logging_warmup_method_classic(inputs)
});
export { workout_logging_warmup_method_classic as "workout-logging.warmup_method_classic" }